
import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { State } from 'vuex-class';
import { Form, FormItem, Input } from 'element-ui';
import api from '@/api/asset';
import Util from '@/libs/util';
import { ITButton } from '@/components/Button/index.d';
import Button from '@/components/Button/tButton.vue';
import tModal from '@/components/Modal/index.vue';

@Component({
  components: {
    Form,
    FormItem,
    Input,
    tModal,
    Button,
  },
})
export default class SearchForm extends Vue {
  @Prop({
    required: true,
  }) visible!: boolean;

  @Prop({
    required: true,
  }) title!: string;

  @Prop({
    required: true,
  }) data!: any;

  @Prop({
    required: true,
  }) close!: Function;

  private form: any = {
    title: '',
  };

  private rules: { [key: string]: Array<object> } = {
    title: [
      { required: true, message: '素材名称不可为空', trigger: 'blur' },
    ],
  };

  private loading: { [key: string]: boolean } = { submit: false };

  public $refs!: {
    form: Form,
  };

  private subBtn: ITButton = {
    title: '确 定',
    type: 'primary',
    icon: '',
    callback: () => this.handleSubmit(),
  };

  /**
   * @author terry
   * @desc 清空事件
   */
  handleClear() {
    this.$refs.form.resetFields();
  }

  handleSubmit() {
    this.loading.submit = true;
    (this.$refs.form as Form).validate((valid: boolean) => {
      if (valid) {
        const json = this.data.data;
        json.name = this.form.title;
        if (json.json) json.json.name = this.form.title;
        if (json.source) json.source.name = this.form.title;
        const data = {
          title: this.form.title,
          id: this.data.id,
          materialData: JSON.stringify(json),
        };
        api.editAssetName(data).then(() => {
          this.handleClear();
          this.close(true);
          this.loading.submit = false;
        }).catch(() => {
          this.loading.submit = false;
        });
      } else {
        this.loading.submit = false;
      }
    });
  }
}
